import { Environment } from "./environment.interface";
import { GROUP_CONFIG } from "./group_config";

export const environment:Environment = {
  production: false,
  LandingURL: '/0005Juaoofoxq0e4yUCgayw0c/index',
  sagaTopUrl: 'https://dev.area-timeservice.com/saga/index.html',
  translationTopUrl:'https://dev-translation.area-timeservice.com',
  APIPrefix: 'https://dev.sg.koko-iru.net/tsapi/',
  // APIPrefix: 'https://tr.koko-iru.net/tsapi/',
  LoginURL: 'https://dev.sg.koko-iru.net/ts/',
  GROUP_CONFIG: GROUP_CONFIG,
  analyticsId: 'G-4TT70J4VDJ'
};

